// @ts-nocheck
import React from 'react';
import CustomRadioButton from './CustomRadioButton.jsx';
import BalanceCard from './BalanceCard.jsx';
import TradeCard from './TradeCard.jsx';
import LaunchpadCard from './LaunchpadCard.jsx';
import ClipLoader from 'react-spinners/ClipLoader';
import { chainLogos, scanLinks, coinNames } from '../utils/constants.ts'; // Assuming these are needed

interface ProfileTabsProps {
    selectedOption: string;
    handleSelect: (value: string) => void;
    funBalances: any[]; // Replace 'any' with actual type
    tradeHistory: any[]; // Replace 'any' with actual type
    funLists: any[]; // Replace 'any' with actual type
    loading: boolean;
    currentTransactionPage: number;
    transactionTotalPages: number;
    transactionItemsPerPage: number;
    setCurrentTransactionPage: (page: number | ((prev: number) => number)) => void;
    isOwnProfile: boolean;
    onKycButtonClick: (token: { tokenName: string; contractAddress: string }) => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({
    selectedOption,
    handleSelect,
    funBalances,
    tradeHistory,
    funLists,
    loading,
    currentTransactionPage,
    transactionTotalPages,
    transactionItemsPerPage,
    setCurrentTransactionPage,
    isOwnProfile,
    onKycButtonClick,
}) => {
    return (
        <section className="ProfileBox grow bg-[#6d79ad33] rounded-[10px] lg: px-8 px-2.5 py-5 backdrop-blur-[8px] border-2 border-[#ffffff66]">
            {/* Radio Buttons */}
            <div className="custom-radio-button-wrapper mb-5">
                <CustomRadioButton
                    value="Balances"
                    selectedValue={selectedOption}
                    handleSelect={handleSelect}
                />
                <CustomRadioButton
                    value="Trades"
                    selectedValue={selectedOption}
                    handleSelect={handleSelect}
                />
                <CustomRadioButton
                    value="Deploys"
                    selectedValue={selectedOption}
                    handleSelect={handleSelect}
                />
            </div>

            {/* Content based on selectedOption */}
            {selectedOption === 'Balances' && (
                <>
                    {loading ? (
                        <div className="flex flex-col gap-2 w-full items-center py-10">
                            <p className="Text1" style={{ color: 'white' }}>Loading Balances...</p>
                            <ClipLoader color={'#afccc6'} loading={true} size={50} />
                        </div>
                    ) : funBalances.length > 0 ? (
                        funBalances.map(({ chainId, name, symbol, contractAddress, logoUrl, balance }, i) => (
                            symbol ? (
                                <div key={`${contractAddress}-${chainId}-${i}`}>
                                    <BalanceCard
                                        chainId={chainId}
                                        chainLogo={chainLogos[chainId]}
                                        name={name}
                                        symbol={symbol}
                                        contractAddress={contractAddress}
                                        Logo={<img src={logoUrl} className="balance-token-logo" alt={`${name} logo`} />}
                                        balance={balance}
                                    />
                                </div>
                            ) : (
                                <div key={`invalid-balance-${i}`}>Invalid balance data</div>
                            )
                        ))
                    ) : (
                        <div className='text-white text-center py-10'>No Balances Found</div>
                    )}
                </>
            )}

            {selectedOption === 'Trades' && (
                <>
                    <div className='trade-box'>
                        <div className='balanceContent'>
                            <div className="trade-header-container py-2">
                                <p className="Balance-token-name left-aligned">Token</p>
                                <p className="Balance-token-name left-aligned">Type</p>
                                <p className="Balance-token-name left-aligned">Amount</p>
                                <p className="Balance-token-name left-aligned">Date</p>
                            </div>
                        </div>
                    </div>
                    {loading && selectedOption === 'Trades' ? (
                         <div className="flex flex-col gap-2 w-full items-center py-10">
                            <p className="Text1" style={{ color: 'white' }}>Loading Trades...</p>
                            <ClipLoader color={'#afccc6'} loading={true} size={50} />
                        </div>
                    ) : tradeHistory.length > 0 ? (
                        <>
                            {tradeHistory.slice(
                                (currentTransactionPage - 1) * transactionItemsPerPage,
                                currentTransactionPage * transactionItemsPerPage
                            ).map(({ chainId, amount, name, token, type, date, contract }, i) => (
                                <TradeCard
                                    key={`${contract}-${type}-${i}-${date}`}
                                    name={name || 'N/A'}
                                    amount={amount}
                                    token={token || 'N/A'}
                                    type={type || 'N/A'}
                                    date={date}
                                    scanLink={scanLinks[chainId]}
                                    coinName={coinNames[Number(chainId)]}
                                    contractAddress={contract}
                                />
                            ))}
                            {tradeHistory.length > transactionItemsPerPage && (
                                <div className="flex justify-center my-4 border border-gray-600 rounded-[10px] w-fit mx-auto">
                                    <button
                                        onClick={() => setCurrentTransactionPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentTransactionPage === 1}
                                        className="px-3 py-1 text-white disabled:opacity-50"
                                    >
                                        &lt;
                                    </button>
                                    <span className="px-3 py-1 text-white">
                                        {currentTransactionPage} / {transactionTotalPages}
                                    </span>
                                    <button
                                        onClick={() => setCurrentTransactionPage(prev => Math.min(prev + 1, transactionTotalPages))}
                                        disabled={currentTransactionPage === transactionTotalPages}
                                        className="px-3 py-1 text-white disabled:opacity-50"
                                    >
                                        &gt;
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className='trades-box py-10 text-sm text-white text-center'>No Trades Found</div>
                    )}
                </>
            )}

            {selectedOption === 'Deploys' && (
                <>
                    {loading ? (
                         <div className="flex flex-col gap-2 w-full items-center py-10">
                            <p className="Text1" style={{ color: 'white' }}>Loading Deploys...</p>
                            <ClipLoader color={'#afccc6'} loading={true} size={50} />
                        </div>
                    ) : funLists.length > 0 ? (
                        <div className="launchpad-card-grid">
                            {funLists.map(({
                                chainId, progress, Liquidity, tokenName, tokenDescription, logoUrl, bannerUrl,
                                address: funAddress, depositedAmount, contractAddress, tokenAddress, dexAddress,
                                devAddress, dexName, marketCap, website, twitter, telegram, blockchainLogoUrl
                            }, i) => (
                                tokenName !== '' ? (
                                    <LaunchpadCard
                                        key={`${contractAddress}-${chainId}-${i}`}
                                        chainId={chainId}
                                        progress={progress}
                                        Liquidity={Liquidity}
                                        tokenName={tokenName}
                                        tokenDescription={tokenDescription}
                                        Logo={<img src={logoUrl} className="claim-card-logo" alt={`${tokenName} logo`} />}
                                        Banner={bannerUrl}
                                        funAddress={funAddress}
                                        depositedAmount={depositedAmount}
                                        contractAddress={contractAddress}
                                        tokenAddress={tokenAddress}
                                        dexAddress={dexAddress}
                                        devAddress={devAddress}
                                        dexName={dexName}
                                        marketCap={marketCap}
                                        website={website}
                                        twitter={twitter}
                                        telegram={telegram}
                                        BlockchainLogo={<img src={blockchainLogoUrl} className="launchpad-blockchain-logo" alt={`${chainId} logo`} />}
                                        showKYCButton={isOwnProfile}
                                        onKycButtonClick={() => onKycButtonClick({ tokenName, contractAddress })}
                                    />
                                ) : null
                            ))}
                        </div>
                    ) : (
                        <div className='text-white text-center py-10'>No Deploys Found</div>
                    )}
                </>
            )}
        </section>
    );
};

export default ProfileTabs;
